<template>
  <div>
    <div class="checkin__last-call  checkin__last-call--det mt-4 d-block d-md-flex align-items-center justify-content-between" v-if="!expired">
      <div class="mb-2 mb-md-0">
        <Icon name="infoCircle" width="20" class="mr-2"/>
        {{ message }}
      </div>
      <div class="text-right">
        <b-button size="sm" class="text-nowrap" variant="outline" @click="$bvModal.show('modal-last-chance-hd')">
          {{ $t('pages.checkin_info_media.cta') }}
        </b-button>
      </div>
    </div>
    <ModalRetention :message="modalMessage"
                    :title="$t('pages.checkin_info_media.modal_title')"
                    :label-cta="$t('pages.checkins.last_call_modal_btn')" />
  </div>
</template>


<script>
import ModalRetention from "@/domain/checkin/ModalRetention.vue";

export default {
  name: "InfoSdHdAvailable",
  components: {ModalRetention},
  props: {
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    hdAvailableToFormatted() {
      return this.$options.filters.formatDate(this.hdAvailableTo)
    },
    expired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
    message() {
      return this.$t('pages.checkin_info_media.message', {date: this.hdAvailableToFormatted})
    },
    modalMessage() {
      const text = this.$t('pages.checkin_info_media.modal', {
        date: this.$options.filters.formatDate(this.hdAvailableTo, 'dddd L')
      })
      return this.$options.filters.capitalize(text)
    },
  },
}
</script>

<style scoped>

</style>